module.exports = __webpack_public_path__ + "static/media/AzoSansBlack.0a7e9d7e.woff";